import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'data-preview-component',
  templateUrl: './data-preview.component.html',
  styleUrls: ['./data-preview.component.scss'],
})
export class DataPreviewComponent implements OnInit {
  showBackToNewTask = false;
  isStarterUser = false;

  @Input() inlineMode = false;
  @Output() backClicked = new EventEmitter<void>();

  constructor(
    @Optional() public dialogRef: MatDialogRef<DataPreviewComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.isStarterUser = (this.authService.userValue as any)?.user_plan === 1;
  }

  closeDialog() {
    this.dialogRef.close();
  }

    backToNewTask(): void {
    if (this.inlineMode) {
      this.backClicked.emit();
      return;
    }
  }
  
}
